import { ShopProduct } from "core/catalog";
import { ArrowRight, Button } from "~/design-system/components";
import { NoResults } from "./NoResult";

type RecentSearchesProps = {
  recentSearches: [string, ShopProduct[]][];
  handleSearch: (search: string) => void;
};

export function RecentSearches({
  recentSearches,
  handleSearch,
}: RecentSearchesProps) {
  if (recentSearches.length === 0)
    return <NoResults message="No recent searches" />;

  return (
    <div className="flex flex-col gap-2 pt-4">
      {recentSearches.slice(0, 5).map(([query], index) => (
        <Button
          onClick={() => handleSearch(query)}
          key={index}
          className="hover:bg-primary-100 flex cursor-pointer items-center justify-between gap-4 rounded-xl px-4 py-2 duration-300"
        >
          {query}
          <ArrowRight className="size-5 -rotate-45" />
        </Button>
      ))}
    </div>
  );
}
